// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2djIw","title":"Header_title__3kjog","left":"Header_left__1iQAX","clinicName":"Header_clinicName__2i61g"};